import * as actionTypes from '../actions/actionTypes';
import { updateObject } from './../../utility/utility';

const initialState = {
    projects: null,
    currentProject: null,
    loading: false,
    error: null,
    NotFoundStatus: false
}

const fetchProjectsStart = (state) => {
    return updateObject(state, {
        error: null,
        loading: true
    })
}

const fetchProjectsSuccess = (state, action) => {
    return updateObject(state, {
        loading: false,
        projects: action.projects
    })
}

const fetchProjectsFail = (state, action) => {
    return updateObject(state, {
        loading: false,
        error: action.error
    })
}

const projectClicked = (state, action) => {
    return updateObject(state, {
        NotFoundStatus: false,
        currentProject: action.currentProject
    })
}

const fetchParticularProjectStart = (state) => {
    return updateObject(state, {
        loading: true,
        error: null,
        NotFoundStatus: false
    })
}

const fetchParticularProjectSuccess = (state, action) => {
    return updateObject(state, {
        loading: false,
        currentProject: action.currentProject
    })
}

const fetchParticularProjectFail = (state, action) => {
    return updateObject(state, {
        loading: false,
        error: action.error
    })
}

const fetchParticularProjectOnPageLoadFail = (state) => {
    return updateObject(state, {
        loading: false
    })
}

const fetchedProjectNotFound = (state) => {
    return updateObject(state, {
        NotFoundStatus: true
    })
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.FETCH_PROJECTS_START: return fetchProjectsStart(state)

        case(actionTypes.FETCH_PROJECTS_SUCCESS): return fetchProjectsSuccess(state, action)

        case(actionTypes.FETCH_PROJECTS_FAIL): return fetchProjectsFail(state, action)

        case(actionTypes.PROJECT_CLICKED): return projectClicked(state, action)

        case(actionTypes.FETCH_PARTICULAR_PROJECT_START): return fetchParticularProjectStart(state)

        case(actionTypes.FETCH_PARTICULAR_PROJECT_SUCCESS): return fetchParticularProjectSuccess(state, action)

        case(actionTypes.FETCH_PARTICULAR_PROJECT_FAIL): return fetchParticularProjectFail(state, action)

        case(actionTypes.FETCH_PARTICULAR_PROJECT_ON_PAGE_LOAD_FAIL): return fetchParticularProjectOnPageLoadFail(state)

        case(actionTypes.FETCHED_PROJECT_NOT_FOUND): return fetchedProjectNotFound(state)
        
        default: return state
    }
}

export default reducer;